import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  CustomLabel,
  ProtectionWatermarkMode,
  ProtectionWatermarkSource,
} from '../../../../graphql';
import { ReplaySubject } from 'rxjs';
import { UploadService } from 'ZalamoLibrary/src/lib/upload/upload.service';
import { switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'app-watermark-preview',
    templateUrl: './watermark-preview.component.html',
    styleUrls: ['./watermark-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WatermarkPreviewComponent implements OnInit {
  @Input() opacity = 0.8;
  @Input() lineOpacity = 0.8;
  @Input() source: ProtectionWatermarkSource = ProtectionWatermarkSource.Text;

  @Input() showLines = true;
  @Input() mode: ProtectionWatermarkMode = ProtectionWatermarkMode.Multi;
  startSize = 20;
  @ViewChild('textElement', { static: false })
  textNode: ElementRef<SVGTextElement>;
  fileName$ = new ReplaySubject<string>(1);
  url$ = this.fileName$.pipe(
    tap((x) => console.log(x)),
    switchMap((fileName) =>
      this.uploadService.getSingleFileUrl(fileName, { h: 400, w: 400 })
    ),
    tap((x) => console.log(x))
  );

  private _text: Array<CustomLabel> = [];

  get text() {
    return this._text;
  }

  @Input() set text(value: Array<CustomLabel>) {
    this._text = value;
    this.fixText();
  }

  @Input() set fileName(fileName) {
    if (fileName) {
      this.fileName$.next(fileName);
    }
  }

  @HostBinding('class.single') get isSingle() {
    return this.mode === 'Single';
  }

  constructor(
    private cd: ChangeDetectorRef,
    private uploadService: UploadService
  ) {}

  test() {
    console.log('datdaawd');
  }

  fixText() {
    if (this.textNode) {
      while (this.textNode.nativeElement.getBoundingClientRect().width > 170) {
        this.startSize--;
        this.cd.detectChanges();
      }
      while (
        this.textNode.nativeElement.getBoundingClientRect().width < 150 &&
        this.startSize !== 25
      ) {
        this.startSize = Math.max(25, this.startSize + 1);
        this.cd.detectChanges();
      }
    }
  }

  ngOnInit(): void {
    this.fixText();
  }
}
